module.exports = __webpack_public_path__ + "static/media/PROD_E3.63684eae.png";